import { Component, Input } from "@angular/core";
import { UntypedFormControl } from "@angular/forms";
import { Option } from "@recore-solutions/nstar-lib";

@Component({
	selector: "app-listing-type-select",
	templateUrl: "./listing-type-select.component.html",
	styleUrls: ["./listing-type-select.component.scss"],
})
export class ListingTypeSelectComponent {
	@Input() control: UntypedFormControl;

	listingClassOptions: Option[] = [
		{ value: "Single Family", key: "SF", sortOrder: 1 },
		{ value: "Multi-Family", key: "MF", sortOrder: 1 },
		{ value: "Lots & Land", key: "LL,LLRLIT", sortOrder: 1 },
		{ value: "Commercial", key: "CMU", sortOrder: 1 },
		{ value: "Residential Rentals", key: "RR", sortOrder: 1 },
		{ value: "Farm", key: "FRM,FRMRLIT", sortOrder: 1 },
	];

	constructor() {}
}
